






import { Vue, Component, Prop, Watch, Emit } from 'vue-property-decorator';

@Component({})
export default class SelectionFieldAction extends Vue {
  @Prop({ type: String, default: 'info' }) actionIcon!: string;
  @Emit()
  action() {
    return;
  }
}
